<button
	*ngIf="showBackButton"
	tlkButton
	variant="secondary"
	size="m"
	class="rx-intuitive-teeth-diagram-footer__back-btn"
	[attr.aria-label]="'ToothEditor.BackToToothchart' | translate"
	(click)="onBackToToothchart()"
>
	<tlk-arrow-up-icon />
	{{ 'ToothEditor.BackToToothchart' | translate }}
</button>
